import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { MdPhone } from "react-icons/md";
import {Container, Row, Col, Box} from '../../../../components/ui/wrapper'
import Heading from '../../../../components/ui/heading'
import Text from '../../../../components/ui/text'
import Anchor from '../../../../components/ui/anchor'
import Button from '../../../../components/ui/button'
import {SectionWrap, ContactInfoBox} from './contact.style'

const ContactArea = (props) => {
    const contactQueryData = useStaticQuery(graphql `
        query {
            homeTechSection(id: {eq: "contact-content"}) {
                bg_image
              }
            contactData: site {
                siteMetadata {
                  contact {
                    phone
                  }
                }
            }
        } 
    `);
    const {bg_image} = contactQueryData.homeTechSection;
    const {phone} = contactQueryData.contactData.siteMetadata.contact;
    const { headingStyle, descStyle, conactInfoStyles:{titleStyle, phoneAnchorStyle, btnStyle} } = props;
    return (
        <SectionWrap src={bg_image}>
            <Container>
                <Row alignitems="center">
                    <Col lg={6}>
                        <Box>
                            <Heading {...headingStyle}>Obtaining further information by <span>make a contact</span> with our experienced IT staffs.</Heading>
                            <Text {...descStyle}>Feel free to contact us  by telephone or email to story more.<br/>We will get back to you as soon as possible. </Text>
                        </Box>
                    </Col>
                    <Col lg={6}>
                        <ContactInfoBox>
                            <MdPhone className="icon"/>
                            <Heading {...titleStyle}>REACH OUT NOW!</Heading>
                            {phone && (
                                <Heading><Anchor path="/contact-us" {...phoneAnchorStyle}>{phone}</Anchor></Heading>
                            )}
                            <Button to="/contact-us" {...btnStyle}>Contact Us</Button>
                        </ContactInfoBox>
                    </Col>
                </Row>
            </Container>
        </SectionWrap>
    )
}

ContactArea.propTypes = {
    headingStyle: PropTypes.object
}

ContactArea.defaultProps = {
    headingStyle: {
        as: 'h3',
        position: 'relative',
        pl: '34px',
        fontweight: 600,
        lineHeight: 1.4,
        color: '#fff',
        before: {
            top: '50%',
            width: '4px',
            height: '94%',
            bgColor: 'secondary',
            transform: 'translateY(-50%)'
        }
    },
    descStyle: {
        mt: '15px',
        fontSize: '18px',
        color: '#fff',
        ml: '34px'
    },
    conactInfoStyles: {
        titleStyle: {
            as: 'h6',
            fontSize: '15px',
            color: '#fff',
            letterspacing: '2px',
            texttransform: 'uppercase',
            mb: '10px',
            mt: '10px',
        },
        phoneAnchorStyle: {
            color: 'secondary',
            hover: {
                layout: 2,
                color: 'secondary'
            }
        },
        btnStyle: {
            mt: '20px',
            skin: 'light',
            minwidth: '230px',
            color: 'primary',
            hover: {
                bgColor: 'secondary'
            }
        }
    }
}

export default ContactArea;